import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import {MatTableDataSource, MatPaginator, MatSort,} from '@angular/material';
import * as $ from 'jquery';

var COMP = environment.component.transparency;
export interface Element {
    column1: string;
    column2: string;
    column3: string;
    column4: string;
    column5: number;
    column6: string;
    column7: string;
    column8: string;
    column9: string;
  }

  const ELEMENT_DATA: Element[] =[
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 3,
      column6: "Yes",
      column7: "Whistleblower protection: encouraging reporting",
      column8: "Are protected disclosures and persons afforded protection clearly defined?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 5,
      column6: "Yes",
      column7: "Whistleblower protection: encouraging reporting",
      column8: "Are remedies and sanctions for retaliation clearly outlined?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 4,
      column6: "Yes",
      column7: "Whistleblower protection: encouraging reporting",
      column8: "Are retaliatory actions clearly defined and the protection afforded robust and comprehensive?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 2,
      column6: "Yes",
      column7: "Whistleblower protection: encouraging reporting",
      column8: "Are there effective institutional frameworks and clear procedures and channels in place for facilitating the reporting of wrongdoing and corruption?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 6,
      column6: "Yes",
      column7: "Whistleblower protection: encouraging reporting",
      column8: "Is awareness-raising regularly undertaken to encourage the reporting of wrongdoing and corruption and to disseminate existing information on the protection of whistleblowers?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 1,
      column6: "No",
      column7: "Whistleblower protection: encouraging reporting",
      column8: "Is there comprehensive and clear legislation in place to protect from retaliation, discriminatory or disciplinary action, employees who disclose in good faith and on reasonable grounds, suspected acts of wrongdoing or corruption to competent authorities?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 1,
      column6: "No",
      column7: "Regulatory policy: improving governance",
      column8: "Are legal and constitutional practices consistent with and supportive of the rule of law?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 4,
      column6: "Yes",
      column7: "Regulatory policy: improving governance",
      column8: "Are regulations kept simple and have unnecessary administrative burdens been eliminated?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 2,
      column6: "Yes",
      column7: "Regulatory policy: improving governance",
      column8: "Are regulations, regulatory institutions charged with implementation, and regulatory processes transparent and accessible?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 3,
      column6: "Yes",
      column7: "Regulatory policy: improving governance",
      column8: "Has the proposed regulation been analysed to identify that it is a necessary and effective means of achieving a legitimate policy goal?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 5,
      column6: "Yes",
      column7: "Regulatory policy: improving governance",
      column8: "Is regulatory enforcement and inspection effectively set for fighting corruption?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 4,
      column6: "Yes",
      column7: "Public sector integrity: providing services efficiently",
      column8: "Controls - Are effective internal control mechanisms in place and are they closely coordinated with external controls to avoid loopholes?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 1,
      column6: "No",
      column7: "Public sector integrity: providing services efficiently",
      column8: "Enabling environment - Do political leaders demonstrate high standards of propriety in the discharge of their official duties?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 2,
      column6: "Yes",
      column7: "Public sector integrity: providing services efficiently",
      column8: "Integrity standards - Do public officials know the fundamental values of the public service and standards of conduct to apply in their daily work?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 5,
      column6: "Yes",
      column7: "Public sector integrity: providing services efficiently",
      column8: "Openness – Are mechanisms in place to enable civil society organisations, media and the wider public to scrutinise government actions?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 3,
      column6: "Yes",
      column7: "Public sector integrity: providing services efficiently",
      column8: "Risk mapping - Have risks to integrity been identified in key government activities and were countermeasures developed to manage these risks?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 5,
      column6: "No",
      column7: "Lobbying: influencing decision making with transparency and integrity",
      column8: "Are tax authorities authorised to report suspicions of corruption to the appropriate domestic law enforcement authorities?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 3,
      column6: "No",
      column7: "Lobbying: influencing decision making with transparency and integrity",
      column8: "Are the rules and guidelines on lobbying consistent with the wider policy and regulatory frameworks?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 4,
      column6: "No",
      column7: "Lobbying: influencing decision making with transparency and integrity",
      column8: "Are the terms “lobbying” and “lobbyist” clearly defined in the rules and guidelines on lobbying?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 7,
      column6: "No",
      column7: "Lobbying: influencing decision making with transparency and integrity",
      column8: "Are there clear rules and guidelines of conduct for public officials on how to engage with lobbyists?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 6,
      column6: "No",
      column7: "Lobbying: influencing decision making with transparency and integrity",
      column8: "Can lobbying activities be scrutinised by stakeholders?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 1,
      column6: "Yes",
      column7: "Lobbying: influencing decision making with transparency and integrity",
      column8: "Do all stakeholders have fair and equitable access to the development and implementation of public policies?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 8,
      column6: "No",
      column7: "Lobbying: influencing decision making with transparency and integrity",
      column8: "Do lobbyists comply with standards of professionalism and transparency?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 2,
      column6: "No",
      column7: "Lobbying: influencing decision making with transparency and integrity",
      column8: "Do rules and guidelines on lobbying respect the socio-political and administrative context?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 4,
      column6: "No",
      column7: "Lobbying: influencing decision making with transparency and integrity",
      column8: "Do tax administrations provide guidance and training to tax examiners as to the types of payments that are deemed to constitute bribes and the actions to take when they suspect a bribe has been paid?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 6,
      column6: "No",
      column7: "Lobbying: influencing decision making with transparency and integrity",
      column8: "Do tax administrations provide guidance to tax examiners to facilitate reporting of suspicions of foreign bribery arising out of the performance of their duties to the appropriate domestic law enforcement authorities?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 2,
      column6: "No",
      column7: "Lobbying: influencing decision making with transparency and integrity",
      column8: "Do tax administrations raise awareness among taxpayers that bribes are not deductible? Is this message disseminated through regular contacts with tax advisors and accountancy firms, through the organisation’s website or other communications tools?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 3,
      column6: "No",
      column7: "Lobbying: influencing decision making with transparency and integrity",
      column8: "Do tax authorities include corruption in their risk assessment and audit processes and encourage tax examiners to carry out relevant compliance checks?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 8,
      column6: "No",
      column7: "Lobbying: influencing decision making with transparency and integrity",
      column8: "Do tax authorities use tax information sharing agreements with other countries to obtain and provide information to determine whether a deducted payment constitutes a bribe?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 1,
      column6: "No",
      column7: "Lobbying: influencing decision making with transparency and integrity",
      column8: "Do tax systems explicitly disallow tax deductions for bribes to public officials?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 7,
      column6: "No",
      column7: "Lobbying: influencing decision making with transparency and integrity",
      column8: "Do tax treaties allow the use of information provided by a treaty partner for tax purposes to combat serious crimes such as corruption under certain circumstances?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 5,
      column6: "No",
      column7: "Lobbying: influencing decision making with transparency and integrity",
      column8: "Is sufficient information on lobbying activities publicly available?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 10,
      column6: "No",
      column7: "Lobbying: influencing decision making with transparency and integrity",
      column8: "Is the functioning of rules and guidelines on lobbying periodically reviewed to ensure compliance?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 9,
      column6: "No",
      column7: "Lobbying: influencing decision making with transparency and integrity",
      column8: "Is there a coherent spectrum of strategies and practices to ensure compliance with rules on lobbying?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 6,
      column6: "No",
      column7: "Investigative media, Media Ownership",
      column8: "Do laws or procedures exist that oblige media owners to reveal their business interests (and business that such owners may have with government) to the public?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 7,
      column6: "No",
      column7: "Investigative media, Media Ownership",
      column8: "Do the foreign media have the same rights as the domestic media to cover and report stories?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 4,
      column6: "No",
      column7: "Investigative media, Media Ownership",
      column8: "Is there a mix of privately-owned and publicly-owned media and is the latter independent from government influence as to editorial control? If so, how is editorial independence ensured?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 5,
      column6: "No",
      column7: "Investigative media, Media Ownership",
      column8: "Is there competition within the (a) print media, (b) television, (c) radio, (d) web? Do antimonopoly laws exist to secure competition and, if so, are they enforced?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 9,
      column6: "No",
      column7: "Investigative media, Investigative Journalism",
      column8: "Are journalists guaranteed to keep their information sources private? If so, how is this ensured?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 8,
      column6: "No",
      column7: "Investigative media, Investigative Journalism",
      column8: "Are journalists who expose corruption or investigate the interests of powerful private and public sector leaders effectively pr",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 10,
      column6: "No",
      column7: "Investigative media, Investigative Journalism",
      column8: "Have the media put in place some form of self-regulation (e. g. codes of conduct, press councils) to ensure media ethics and accountability?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 1,
      column6: "No",
      column7: "Investigative media, Freedom of Information",
      column8: "Are freedom of information laws and procedures in place to ensure that members of the public can obtain information from public authorities?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 2,
      column6: "No",
      column7: "Investigative media, Freedom of Information",
      column8: "If an “Official Secrets Act” or similar legislation is in place, is it only used in exceptional situations, such as those menacing national security, and not as a means to secure censorship of the media by government? What are the procedures and criteria for determining whether a specific piece of information may be kept secret?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 3,
      column6: "No",
      column7: "Investigative media, Freedom of Information",
      column8: "Is freedom of expression ensured and is there any form of censorship applied to printed or online media (including social media)? Are libel laws used only in appropriate cases and in particular not used to curb the dissemination of corruption cases?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 8,
      column6: "No",
      column7: "Development co-operation: building stronger country systems",
      column8: "Are appropriate sanctions such as debarment to compete for aid funded contracts in place for companies and individuals involved in corrupt activities like bribery of foreign officials, bid rigging, etc.?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 4,
      column6: "Yes",
      column7: "Development co-operation: building stronger country systems",
      column8: "Are non-state actors (civil society, private sector, media) effectively supported to act as external monitors of anti corruption efforts and demand accountability?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 5,
      column6: "Yes",
      column7: "Development co-operation: building stronger country systems",
      column8: "Do donor countries actively support efforts to control the supply side of corruption including addressing bribery of foreign officials, money laundering and efforts to track, freeze and recover illegally acquired assets originating from developing countries held in OECD countries?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 7,
      column6: "Yes",
      column7: "Development co-operation: building stronger country systems",
      column8: "Do donors have in place sufficient mechanisms to prevent and detect fraud and corruption in donor-financed projects and programmes in order to reduce the potential for the diversion of funds?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 9,
      column6: "No",
      column7: "Development co-operation: building stronger country systems",
      column8: "Do donors provide full and timely information on annual commitments and actual disbursements so that developing countries are in a position to accurately record all aid flows in their budget estimates and their accounting systems?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 3,
      column6: "Yes",
      column7: "Development co-operation: building stronger country systems",
      column8: "Do donors support knowledge gathering to assess, measure and report progress on anti-corruption efforts and lessons learned with the purpose of informing policy and operational action, drawing where possible on local capacity?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 2,
      column6: "Yes",
      column7: "Development co-operation: building stronger country systems",
      column8: "Do donors use country systems (public financial management and procurement, for example) as the default option for aid programmes in support of activities managed by the public sector?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 6,
      column6: "No",
      column7: "Development co-operation: building stronger country systems",
      column8: "In cases where government commitment to fight corruption is low, have donors prepared coordinated and graduated responses to corruption scandals and to deteriorating governance?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 1,
      column6: "Yes",
      column7: "Development co-operation: building stronger country systems",
      column8: "Is a shared government-donor vision for anti-corruption dialogue and action designed towards the implementation of international commitments, in particular the United Nations Convention Against Corruption (UNCAC), in place?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 2,
      column6: "No",
      column7: "Criminalising bribery and ensuring enforcement",
      column8: "Corporate liability: Do national legislations hold companies responsible – either criminally or civilly/administratively – for the offences of domestic and foreign bribery?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 8,
      column6: "No",
      column7: "Criminalising bribery and ensuring enforcement",
      column8: "International co-operation: Does effective international co-operation support the investigation and prosecution of bribery cases, especially cases of transnational bribery?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 5,
      column6: "No",
      column7: "Criminalising bribery and ensuring enforcement",
      column8: "Investigative and prosecutorial independence: Are investigations and prosecutions of bribery cases independent from considerations of national economic interest, the potential effect upon relations with another State, and the identity of the individuals or companies involved?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 7,
      column6: "No",
      column7: "Criminalising bribery and ensuring enforcement",
      column8: "Investigative techniques: Do law enforcement authorities have access to the tools they need to effectively investigate the often complex cases of bribery of foreign and domestic public officials?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 4,
      column6: "No",
      column7: "Criminalising bribery and ensuring enforcement",
      column8: "Jurisdiction: When combating the bribery of domestic and foreign officials, can the offence of bribery be punished wherever it has been committed?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 3,
      column6: "No",
      column7: "Criminalising bribery and ensuring enforcement",
      column8: "Sanctions: Is bribery punishable by effective, proportionate, and dissuasive penalties and are bribes and the proceeds of bribes subject to confiscation?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 6,
      column6: "No",
      column7: "Criminalising bribery and ensuring enforcement",
      column8: "Statutes of limitations: Do investigators and prosecutors have a reasonable amount of time to follow a bribery case?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 1,
      column6: "No",
      column7: "Criminalising bribery and ensuring enforcement",
      column8: "The bribery offence: Does your legislation consider the crime of bribery of a public official as a clear and unambiguous offence?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 2,
      column6: "No",
      column7: "Competition policy: promoting efficiency and sound markets",
      column8: "Do you have a competition law that prohibits hard core cartel agreements and provides the necessary enforcement tools to uncover such illegal practices (e.g. leniency programmes, investigative powers, etc.)?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 3,
      column6: "No",
      column7: "Competition policy: promoting efficiency and sound markets",
      column8: "Do you have a competition law that prohibits the anti-competitive conduct by a dominant firm?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 4,
      column6: "No",
      column7: "Competition policy: promoting efficiency and sound markets",
      column8: "Do you have a competition law that provides for the review of mergers or acquisitions between firms that can harm competition in your jurisdiction?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 1,
      column6: "No",
      column7: "Competition policy: promoting efficiency and sound markets",
      column8: "Do you have an independent and well-resourced competition authority with the necessary powers to effectively enforce competition law?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 9,
      column6: "No",
      column7: "Competition policy: promoting efficiency and sound markets",
      column8: "Does the competition authority review and advise other parts of Government and the Legislature on proposed policies for their effect on competition?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 5,
      column6: "No",
      column7: "Competition policy: promoting efficiency and sound markets",
      column8: "Does the competition law establish the consequences (e.g. fines and sanctions) of substantive competition law infringements so as to ensure sufficient deterrence?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 6,
      column6: "No",
      column7: "Competition policy: promoting efficiency and sound markets",
      column8: "Does your country provide a system that allows those who have suffered the consequences of competition law infringements to be compensated for their losses and for the damages they have incurred?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 7,
      column6: "No",
      column7: "Competition policy: promoting efficiency and sound markets",
      column8: "Does your jurisdiction allow for competition authority decisions to be reviewed by an independent judicial body?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: 8,
      column6: "No",
      column7: "Competition policy: promoting efficiency and sound markets",
      column8: "Does your jurisdiction provide a sufficiently transparent and fair process for the actions of the competition authority?",
      column9: ""
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide\n4.1 Accountability - Enabling environment",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity-development/undp-capacity-assessment-methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: 4.1,
      column6: "No",
      column7: "Formulate Policies and Strategies:\nDo authorities have the capacity to develop and manage accountability mechanisms to ensure formulation of clear and transparent policies and strategies?",
      column8: "Extent to which societal changes are integrated into government's mutual accountability mechanisms",
      column9: ""
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide\n4.1 Accountability - Enabling environment",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity-development/undp-capacity-assessment-methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: 4.1,
      column6: "No",
      column7: "Formulate Policies and Strategies:\nDo authorities have the capacity to develop and manage accountability mechanisms to ensure formulation of clear and transparent policies and strategies?",
      column8: "Quality of mechanisms that ensure mutual accountability",
      column9: ""
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide\n4.2 Accountability - Organizational level",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity-development/undp-capacity-assessment-methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: 4.2,
      column6: "Yes",
      column7: "Formulate Policies and Strategies:\nDoes the organization have the capacity to develop and manage accountability mechanisms to ensure formulation of clear and transparent policies and strategies?",
      column8: "Existence of organizational structures of accountability to clients and constituents",
      column9: ""
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide\n4.2 Accountability - Organizational level",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity-development/undp-capacity-assessment-methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: 4.2,
      column6: "Yes",
      column7: "Formulate Policies and Strategies:\nDoes the organization have the capacity to develop and manage accountability mechanisms to ensure formulation of clear and transparent policies and strategies?",
      column8: "Quality of mechanisms that ensure mutual accountability",
      column9: ""
    },
    {
      column1: "Water Integrity Network",
      column2: "http://www.waterintegritynetwork.net/imtoolbox/water-integrity-risks-tools-index/",
      column3: "None found",
      column4: "None",
      column5: null,
      column6: "Yes",
      column7: "Integrity Training",
      column8: "Does the integrity training include all relevant integrity policies and procedures, both internal and external?",
      column9: "http://www.waterintegritynetwork.net/imtoolbox/code-of-conduct/"
    },
    {
      column1: "Water Integrity Network",
      column2: "http://www.waterintegritynetwork.net/imtoolbox/water-integrity-risks-tools-index/",
      column3: "None found",
      column4: "None",
      column5: null,
      column6: "No",
      column7: "Code of Conduct",
      column8: "Do you have other anti-corruption policies in place? Does your code of conduct comply with them?",
      column9: "http://www.waterintegritynetwork.net/imtoolbox/code-of-conduct/"
    },
    {
      column1: "Water Integrity Network",
      column2: "http://www.waterintegritynetwork.net/imtoolbox/water-integrity-risks-tools-index/",
      column3: "None found",
      column4: "None",
      column5: null,
      column6: "No",
      column7: "Code of Conduct",
      column8: "Does your code of conduct comply with national and international policies on anti-corruption and compliance?",
      column9: "http://www.waterintegritynetwork.net/imtoolbox/code-of-conduct/"
    },
    {
      column1: "Water Integrity Network",
      column2: "http://www.waterintegritynetwork.net/imtoolbox/water-integrity-risks-tools-index/",
      column3: "None found",
      column4: "None",
      column5: null,
      column6: "No",
      column7: "Anti-corruption commitments",
      column8: "Are you aware of international and national anti-corruption policies? Does the anti-corruption commitment comply with these?",
      column9: "http://www.waterintegritynetwork.net/imtoolbox/anti-corruption-commitments/"
    },
    {
      column1: "Water Integrity Network",
      column2: "http://www.waterintegritynetwork.net/imtoolbox/water-integrity-risks-tools-index/",
      column3: "None found",
      column4: "None",
      column5: null,
      column6: "No",
      column7: "Anti-corruption commitments",
      column8: "Do you have adequate communication channels in place to ensure your staff’s awareness of the anti-corruption commitment?",
      column9: "http://www.waterintegritynetwork.net/imtoolbox/anti-corruption-commitments/"
    },
    {
      column1: "Water Integrity Network",
      column2: "http://www.waterintegritynetwork.net/imtoolbox/water-integrity-risks-tools-index/",
      column3: "None found",
      column4: "None",
      column5: null,
      column6: "Yes",
      column7: "Anti-corruption commitments",
      column8: "Do you have control mechanisms in place to ensure your staff’s compliance with anti-corruption commitments?",
      column9: "http://www.waterintegritynetwork.net/imtoolbox/anti-corruption-commitments/"
    },
    {
      column1: "Water Integrity Network",
      column2: "http://www.waterintegritynetwork.net/imtoolbox/water-integrity-risks-tools-index/",
      column3: "None found",
      column4: "None",
      column5: null,
      column6: "Yes",
      column7: "Anti-corruption commitments",
      column8: "Do you possess sufficient bargaining power to enforce the anti-corruption commitment vis-à-vis external partners?",
      column9: "http://www.waterintegritynetwork.net/imtoolbox/anti-corruption-commitments/"
    },
    {
      column1: "World Bank Governance Indicators",
      column2: "http://info.worldbank.org/governance/wgi/index.aspx#home",
      column3: "World Bank Governance Indicators",
      column4: "http://info.worldbank.org/governance/wgi/index.aspx#home",
      column5: null,
      column6: "No",
      column7: "Voice and Accountability",
      column8: "Perceptions of the extent to which a country's citizens are able to participate in selecting their government, as well as freedom of expression, freedom of association, and a free media.",
      column9: "The World Bank Governance Indicators project (WGI) represents indicators in several ways. More informaiton is available at: http://info.worldbank.org/governance/wgi/index.aspx#home"
    },
    {
      column1: "World Bank Governance Indicators",
      column2: "http://info.worldbank.org/governance/wgi/index.aspx#home",
      column3: "World Bank Governance Indicators",
      column4: "http://info.worldbank.org/governance/wgi/index.aspx#home",
      column5: null,
      column6: "No",
      column7: "Rule of Law",
      column8: "Perceptions of the extent to which agents have confidence in and abide by the rules of society, and in particular the quality of contract enforcement, property rights, the police, and the courts, as well as the likelihood of crime and violence.",
      column9: "The World Bank Governance Indicators project (WGI) represents indicators in several ways. More informaiton is available at http://info.worldbank.org/governance/wgi/index.aspx#home"
    },
    {
      column1: "World Bank Governance Indicators",
      column2: "http://info.worldbank.org/governance/wgi/index.aspx#home",
      column3: "World Bank Governance Indicators",
      column4: "http://info.worldbank.org/governance/wgi/index.aspx#home",
      column5: null,
      column6: "No",
      column7: "Regulatory Quality",
      column8: "Perceptions of the ability of the government to formulate and implement sound policies and regulations that permit and promote private sector development.",
      column9: "The World Bank Governance Indicators project (WGI) represents indicators in several ways. More informaiton is available at http://info.worldbank.org/governance/wgi/index.aspx#home"
    },
    {
      column1: "World Bank Governance Indicators",
      column2: "http://info.worldbank.org/governance/wgi/index.aspx#home",
      column3: "World Bank Governance Indicators",
      column4: "http://info.worldbank.org/governance/wgi/index.aspx#home",
      column5: null,
      column6: "No",
      column7: "Political Stability and Absence of Violence/Terrorism",
      column8: "Perceptions of the likelihood of political instability and/or politically-motivated violence, including terrorism.",
      column9: "The World Bank Governance Indicators project (WGI) represents indicators in several ways. More informaiton is available at http://info.worldbank.org/governance/wgi/index.aspx#home"
    },
    {
      column1: "World Bank Governance Indicators",
      column2: "http://info.worldbank.org/governance/wgi/index.aspx#home",
      column3: "World Bank Governance Indicators",
      column4: "http://info.worldbank.org/governance/wgi/index.aspx#home",
      column5: null,
      column6: "No",
      column7: "Government Effectiveness",
      column8: "Perceptions of the quality of public services, the quality of the civil service and the degree of its independence from political pressures, the quality of policy formulation and implementation, and the credibility of the government's commitment to such policies.",
      column9: "The World Bank Governance Indicators project (WGI) represents indicators in several ways. More informaiton is available at http://info.worldbank.org/governance/wgi/index.aspx#home"
    },
    {
      column1: "World Bank Governance Indicators",
      column2: "http://info.worldbank.org/governance/wgi/index.aspx#home",
      column3: "World Bank Governance Indicators",
      column4: "http://info.worldbank.org/governance/wgi/index.aspx#home",
      column5: null,
      column6: "No",
      column7: "Control of Corruption",
      column8: "Control of corruption captures perceptions of the extent to which public power is exercised for private gain, including both petty and grand forms of corruption, as well as \"capture\" of the state by elites and private interests.",
      column9: "The World Bank Governance Indicators project (WGI) represents indicators in several ways. More informaiton is available at http://info.worldbank.org/governance/wgi/index.aspx#home"
    }
   ]

@Component({
  selector: 'app-transparency',
  templateUrl: './transparency.component.html',
  styleUrls: ['./transparency.component.css']
})
export class TransparencyComponent implements OnInit {
//@ViewChild(MatPaginator) paginator: MatPaginator;
@ViewChild(MatSort) sort: MatSort;

  displayedColumns = ['column1', 'column2', 'column3', 'column4', 'column5', 'column6', 'column7', 'column8',  'column9'];
  dataSource: MatTableDataSource<Element>;

  constructor(private router: Router) {
    this.dataSource = new MatTableDataSource(ELEMENT_DATA);
   }

  ngOnInit() {
    $(".header_active").removeClass("header_active")
    $(".integrity-click").addClass("header_active")
  }
  ngAfterViewInit() {
    //this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
    addQuestion(){
        this.router.navigateByUrl('/sdg/add-question/'+COMP)
    }
  	quesBtnClick(){
        this.router.navigateByUrl('/sdg/transparency-quest')
    }
    dataBtnClick(){
        this.router.navigateByUrl('/sdg/transparency-data')
    }
    reportBtnClick(){
        this.router.navigateByUrl('/sdg/transparency-report')
    }
    homeBtnClick(){
        this.router.navigateByUrl('/sdg/sdg-home')
    }
}



// WEBPACK FOOTER //
// ./src/app/sdg/transparency/transparency.component.ts